import React, { useState } from 'react';
import { Heart, MessageCircle, Users, Home, Calendar, CheckCircle, Phone, Instagram, Star, Award, Sparkles, TrendingUp } from 'lucide-react';
import '@/App.css';

export default function RaphaelaPortfolio() {
  const [expandedFaq, setExpandedFaq] = useState(null);

  const whatsappNumber = "5511973964922";
  const whatsappMessage = encodeURIComponent("Olá! Vim através do site e gostaria de saber mais sobre os serviços.");

  const lowTicket = [
    {
      icon: MessageCircle,
      title: "Mentoria de Entrada",
      subtitle: "🎯 Comece Aqui!",
      description: "Sessão inicial de avaliação e planejamento",
      highlight: "Conheça a abordagem e defina seu caminho",
      benefits: [
        "Avaliação dos desafios familiares",
        "Definição de estratégias personalizadas",
        "Planejamento de frequência e formato"
      ],
      price: "270,00",
      priceLabel: "sessão inicial",
      badge: "AVALIAÇÃO COMPLETA",
      color: "from-emerald-400 to-teal-500",
      whatsappMsg: "Olá! Quero agendar a Mentoria de Entrada (R$ 270)"
    },
    {
      icon: Heart,
      title: "Terapia Individual",
      subtitle: "Sessão Avulsa",
      description: "Reconecte consigo mesmo",
      benefits: [
        "Trabalhe padrões emocionais",
        "Fortaleça sua identidade própria",
        "Encontre clareza e equilíbrio"
      ],
      price: "170,00",
      priceLabel: "por sessão",
      color: "from-amber-400 to-orange-500",
      whatsappMsg: "Olá! Quero agendar uma sessão de Terapia Individual (R$ 170)"
    }
  ];

  const mediumTicket = [
    {
      icon: Heart,
      title: "Terapia Individual",
      subtitle: "Jornada Completa",
      description: "Jornada de autoconhecimento e cura emocional",
      highlight: "Construa paz interior e felicidade",
      benefits: [
        "Curar padrões emocionais profundos",
        "Construir paz interior duradoura",
        "Desenvolver autoconhecimento real",
        "Acompanhamento personalizado contínuo"
      ],
      price: "1.270,00",
      priceLabel: "jornada completa",
      bonus: "Acompanhamento personalizado + Material de apoio",
      badge: "TRANSFORMAÇÃO PESSOAL",
      color: "from-rose-400 to-pink-500",
      whatsappMsg: "Olá! Tenho interesse na Jornada de Terapia Individual (R$ 1.270)"
    },
    {
      icon: Home,
      title: "Terapia de Casal",
      subtitle: "Pacote Completo",
      description: "Liberação de bloqueios inconscientes",
      benefits: [
        "Romper bloqueios inconscientes",
        "Restaurar respeito e diálogo",
        "Suspensão total de julgamentos",
        "Reconexão emocional profunda"
      ],
      price: "2.700,00",
      priceLabel: "pacote completo",
      bonus: "Feedback individual + Estratégias práticas",
      color: "from-purple-400 to-violet-500",
      whatsappMsg: "Olá! Quero informações sobre a Terapia de Casal (R$ 2.700)"
    },
    {
      icon: MessageCircle,
      title: "Terapia Familiar",
      subtitle: "🔥 Transformação Familiar",
      description: "Transformação profunda na relação familiar",
      highlight: "Análise comportamental e estratégias na prática",
      benefits: [
        "Análise comportamental detalhada",
        "Estratégias práticas para aplicar no dia a dia",
        "Transforme sua família em ambiente de conexão",
        "Acompanhamento personalizado completo"
      ],
      price: "3.700,00",
      priceLabel: "programa completo",
      bonus: "Material completo + Acompanhamento estendido",
      badge: "RESULTADO GARANTIDO",
      color: "from-blue-500 to-indigo-600",
      whatsappMsg: "Olá! Quero saber mais sobre a Terapia Familiar (R$ 3.700)"
    }
  ];

  const highTicket = [
    {
      icon: Users,
      title: "Mentoria Familiar Completa",
      subtitle: "💎 Investimento Premium",
      description: "Transformação sistêmica de toda a família",
      highlight: "Alinhamento de todos os membros",
      benefits: [
        "Escuta ativa sem julgamento de toda família",
        "Alinhamento completo de todos os membros",
        "Comunicação não-violenta entre todos",
        "Relações saudáveis e duradouras",
        "Acompanhamento personalizado estendido"
      ],
      price: "5.700,00",
      priceLabel: "pacote completo",
      installments: "Parcelamento disponível",
      bonus: "BÔNUS: Alinhamento Familiar + Acompanhamento Personalizado",
      badge: "MÁXIMO RESULTADO",
      color: "from-yellow-400 via-orange-500 to-red-500",
      whatsappMsg: "Olá! Quero saber mais sobre a Mentoria Familiar Completa (R$ 5.700)"
    }
  ];

  const testimonials = [
    {
      text: "Me permitindo tomar o suco na taça!! Gratidão Rapha pelos ensinamentos transmitidos. Lembrei de você ❤️",
      author: "Cliente em transformação",
      type: "Mudança de Hábitos"
    },
    {
      text: "Muito feliz em saber que as sessões, atendimentos personalizados estão sendo positivos, fazendo a mudança na vida da pessoa. Claro que é um conjunto de exercícios, o mentorado colocando em prática não tem como não haver resultado positivo. Somente gratidão 🙏",
      author: "Mãe de adolescente",
      type: "Mentoria Pais"
    },
    {
      text: "Nossa conversa de segunda-feira me ajudou muito, muito mesmo. Esse final de semana já me priorizei em muitas coisas. Já tô arrumando um salão de cabeleireiro, quero cortar o cabelo, quero mudar!",
      author: "Paciente em processo",
      type: "Terapia Individual"
    },
    {
      text: "Quando em apenas uma Sessão de Diagnóstico você já tem uma tomada de consciência, e a mudança começa.",
      author: "Priscila Unha",
      type: "Sessão de Diagnóstico"
    },
    {
      text: "Você é uma pessoa e profissional incrível! Eu fico muito feliz por você.",
      author: "Lívia Amiga Da Nayara",
      type: "Acompanhamento"
    }
  ];

  const faqs = [
    {
      question: "Quais são suas necessidades e desafios específicos?",
      answer: "Entre em contato para conversarmos sobre seus desafios. Assim definimos a melhor comunicação e frequência de encontros, totalmente personalizado conforme sua realidade e necessidade."
    },
    {
      question: "Por onde devo começar?",
      answer: "Comece pela Mentoria de Entrada (R$ 270) para nos conhecermos e analisarmos qual pacote faz sentido para você. É uma sessão completa de avaliação e planejamento personalizado."
    },
    {
      question: "Os atendimentos são online ou presenciais?",
      answer: "Atendimentos em salas humanizadas. Escolha o formato que se adequa melhor à sua rotina: presencial, online ou híbrido. Você tem total flexibilidade!"
    },
    {
      question: "O que inclui a Mentoria Completa?",
      answer: "Uma mentoria que possui análise comportamental detalhada e estratégias na prática, transformando a sua família em um ambiente de conexão e equilíbrio. Acompanhamento personalizado do início ao fim."
    },
    {
      question: "Vocês atendem crianças e adolescentes?",
      answer: "Não atendemos crianças nem adolescentes diretamente. O atendimento é primeiramente com os pais, para entender os desafios e fornecer todo apoio necessário nessa fase intensa."
    },
    {
      question: "Como funciona o pagamento?",
      answer: "Aceitamos PIX e cartão de crédito com parcelamento disponível. Para pacotes, oferecemos condições especiais. Entre em contato para conhecer as opções de pagamento."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50">
      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 text-white p-4 rounded-full shadow-2xl hover:bg-green-600 transition-all z-50 hover:scale-110 animate-pulse pulse-glow magnetic"
        data-testid="whatsapp-floating-button"
      >
        <Phone className="w-7 h-7 animate-pulse" />
      </a>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#0a1a2f] via-[#0d2240] to-[#0a1a2f] py-12 sm:py-16 md:py-20 px-4 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 sm:top-20 -left-20 sm:left-10 w-48 sm:w-72 h-48 sm:h-72 bg-[#c5a467] rounded-full blur-3xl float-animation"></div>
          <div className="absolute bottom-10 -right-20 sm:right-10 w-64 sm:w-96 h-64 sm:h-96 bg-[#c5a467] rounded-full blur-3xl float-animation delay-200"></div>
        </div>
        
        <div className="max-w-6xl mx-auto relative z-10">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="relative bounce-in">
              <div className="w-40 h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-[#c5a467] shadow-2xl hover:shadow-3xl transition-all duration-500 hover:scale-105 morphing-blob">
                <img
                  src="/photo4.jpg"
                  alt="Raphaela Gonçalves - Terapeuta"
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = "https://ui-avatars.com/api/?name=Raphaela+Goncalves&size=300&background=c5a467&color=0a1a2f&bold=true";
                  }}
                />
              </div>
            </div>
            
            <div className="flex-1 text-center md:text-left w-full">
              <div className="inline-flex items-center gap-2 bg-[#c5a467] px-3 sm:px-4 py-2 rounded-full shadow-lg mb-4 fade-in-up hover:scale-105 transition-transform duration-300">
                <Award className="w-4 h-4 sm:w-5 sm:h-5 text-[#0a1a2f]" />
                <span className="text-xs sm:text-sm font-semibold text-[#0a1a2f]">Terapeuta Especializada</span>
              </div>
              
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-2 sm:mb-3 fade-in-up delay-100 leading-tight">
                Raphaela Gonçalves
              </h1>
              <p className="text-lg sm:text-xl md:text-2xl text-[#c5a467] mb-2 sm:mb-3 font-semibold fade-in-up delay-200">Terapeuta e Mentora para Pais</p>
              <p className="text-sm sm:text-base md:text-lg text-stone-200 mb-4 sm:mb-6 leading-relaxed fade-in-up delay-300 max-w-2xl mx-auto md:mx-0">
                Especializada em ajudar pais de adolescentes em conflitos a reconstruírem o diálogo sem gritos e sem culpa.
              </p>
              
              <div className="bg-gradient-to-r from-amber-900/20 to-yellow-900/20 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border-2 border-amber-600/30 mb-4 sm:mb-6 inline-block fade-in-up delay-400 hover:scale-105 transition-transform duration-300">
                <p className="text-amber-100 italic font-medium text-sm sm:text-base md:text-lg">
                  💡 "Quem sustenta a própria consciência sustenta gerações."
                </p>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center md:justify-start w-full fade-in-up delay-500">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-[#c5a467] to-[#d4b574] text-[#0a1a2f] px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:from-[#d4b574] hover:to-[#e3c481] transition-all shadow-xl hover:shadow-2xl flex items-center justify-center gap-2 text-sm sm:text-base liquid-button magnetic"
                  data-testid="hero-schedule-button"
                >
                  <Phone className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span>Agende sua Sessão</span>
                </a>
                <a
                  href="/questionario"
                  className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all shadow-xl hover:shadow-2xl flex items-center justify-center gap-2 text-sm sm:text-base"
                  data-testid="hero-questionnaire-button"
                >
                  <MessageCircle className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span>Apresente seu Problema</span>
                </a>
                <a
                  href="https://instagram.com/heroisdolar"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold hover:from-purple-600 hover:to-pink-600 transition-all shadow-xl hover:shadow-2xl flex items-center justify-center gap-2 text-sm sm:text-base"
                  data-testid="hero-instagram-button"
                >
                  <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
                  <span>@heroisdolar</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-6 sm:py-8 px-4 bg-[#0a1a2f] text-white">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8 text-center stagger-children">
          <div className="fade-in-up delay-100 hover:scale-110 transition-transform duration-300">
            <div className="text-3xl sm:text-4xl font-bold mb-1 sm:mb-2 text-[#c5a467]">70+</div>
            <div className="text-xs sm:text-sm opacity-75 px-2">Famílias Transformadas</div>
          </div>
          <div className="fade-in-up delay-200 hover:scale-110 transition-transform duration-300">
            <div className="text-3xl sm:text-4xl font-bold mb-1 sm:mb-2 text-[#c5a467]">5 Anos</div>
            <div className="text-xs sm:text-sm opacity-75 px-2">de Experiência</div>
          </div>
          <div className="fade-in-up delay-300 hover:scale-110 transition-transform duration-300">
            <div className="text-3xl sm:text-4xl font-bold mb-1 sm:mb-2 text-[#c5a467]">98%</div>
            <div className="text-xs sm:text-sm opacity-75 px-2">Satisfação</div>
          </div>
          <div className="fade-in-up delay-400 hover:scale-110 transition-transform duration-300">
            <div className="text-3xl sm:text-4xl font-bold mb-1 sm:mb-2 text-[#c5a467]">100%</div>
            <div className="text-xs sm:text-sm opacity-75 px-2">Salas Humanizadas</div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-12 sm:py-16 md:py-20 px-4 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0a1a2f] mb-3 sm:mb-4 fade-in-up">Sobre Mim</h2>
            <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-[#c5a467] to-[#d4b574] mx-auto rounded-full fade-in-up delay-100"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8 items-center">
            <div className="space-y-4 sm:space-y-6 fade-in-up delay-200">
              <p className="text-base sm:text-lg text-stone-700 leading-relaxed">
                <strong>Mãe de 2 filhos</strong> (dentre eles uma adolescente), <strong>casada há 18 anos</strong>, 
                pós-graduada em <strong>Psicologia Organizacional e Terapia Sistêmica Familiar e de Casal</strong>. 
                Atuante como terapeuta.
              </p>
              <p className="text-base sm:text-lg text-stone-700 leading-relaxed">
                <strong>Não atendemos crianças nem adolescentes diretamente</strong>. O atendimento é primeiramente 
                com os pais, para entender os desafios, fornecendo todo apoio necessário nessa fase intensa.
              </p>
              <p className="text-base sm:text-lg text-stone-700 leading-relaxed">
                Além da experiência profissional, <strong>vivencio na prática os desafios diários</strong> que 
                as famílias enfrentam. Essa conexão real me permite oferecer estratégias que realmente funcionam.
              </p>
            </div>
            <div className="bg-gradient-to-br from-[#c5a467]/10 to-[#d4b574]/10 backdrop-blur-sm p-6 sm:p-8 rounded-3xl shadow-xl border-2 border-[#c5a467]/30 fade-in-up delay-300 hover:shadow-2xl transition-all duration-500">
              <h3 className="text-xl sm:text-2xl font-bold text-[#0a1a2f] mb-4 sm:mb-6">Minha Abordagem</h3>
              <ul className="space-y-3 sm:space-y-4">
                <li className="flex items-start gap-2 sm:gap-3 hover:translate-x-2 transition-transform duration-300">
                  <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 flex-shrink-0 mt-0.5 sm:mt-1" />
                  <span className="text-sm sm:text-base text-stone-800"><strong>Foco em Solução:</strong> Respeitando a história familiar com suspensão de julgamento</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 hover:translate-x-2 transition-transform duration-300">
                  <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 flex-shrink-0 mt-0.5 sm:mt-1" />
                  <span className="text-sm sm:text-base text-stone-800"><strong>Modelação Comportamental:</strong> Mudanças reais e eficazes</span>
                </li>
                <li className="flex items-start gap-2 sm:gap-3 hover:translate-x-2 transition-transform duration-300">
                  <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6 text-green-600 flex-shrink-0 mt-0.5 sm:mt-1" />
                  <span className="text-sm sm:text-base text-stone-800"><strong>Validação Emocional:</strong> Priorização da sua identidade própria</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* LOW TICKET Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#c5a467] text-[#0a1a2f] px-6 py-2 rounded-full font-bold mb-4">
              <Sparkles className="w-5 h-5" />
              COMECE AQUI - PRIMEIROS PASSOS
            </div>
            <h2 className="text-4xl font-bold text-[#0a1a2f] mb-4">Entre em Contato e Conte Seus Desafios</h2>
            <p className="text-xl text-stone-700">Atendimento ágil e personalizado para sua realidade</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            {lowTicket.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-3xl shadow-2xl border-4 border-emerald-200 hover:border-emerald-400 transition-all hover:shadow-3xl hover:-translate-y-2 relative overflow-hidden tilt-card"
                data-testid={`low-ticket-card-${index}`}
              >
                {service.badge && (
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-4 py-1 rounded-full text-xs font-bold shadow-lg">
                    {service.badge}
                  </div>
                )}
                
                <div className="flex items-center gap-4 mb-6">
                  <div className={`bg-gradient-to-br ${service.color} text-white p-4 rounded-2xl shadow-lg`}>
                    <service.icon className="w-8 h-8" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-stone-900">{service.title}</h3>
                    {service.subtitle && (
                      <p className="text-emerald-600 font-semibold">{service.subtitle}</p>
                    )}
                  </div>
                </div>
                
                <p className="text-stone-700 mb-2 text-lg font-medium">{service.description}</p>
                {service.highlight && (
                  <p className="text-emerald-600 mb-6 font-semibold italic">{service.highlight}</p>
                )}
                
                <ul className="space-y-3 mb-8">
                  {service.benefits.map((benefit, i) => (
                    <li key={i} className="flex items-start gap-2 text-stone-700">
                      <CheckCircle className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>

                <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-6 rounded-2xl border-2 border-emerald-300 mb-6">
                  <div className="text-center">
                    <p className="text-sm text-stone-600 mb-2">{service.priceLabel}</p>
                    <p className="text-5xl font-bold text-stone-900 mb-2">R$ {service.price}</p>
                  </div>
                </div>

                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(service.whatsappMsg)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-emerald-500 to-teal-500 text-white text-center py-4 rounded-xl font-bold hover:from-emerald-600 hover:to-teal-600 transition-all shadow-lg hover:shadow-xl"
                  data-testid={`low-ticket-cta-${index}`}
                >
                  Quero Agendar Agora
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MEDIUM TICKET Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-white to-slate-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#0a1a2f] text-[#c5a467] px-6 py-2 rounded-full font-bold mb-4">
              <TrendingUp className="w-5 h-5" />
              PACOTES COMPLETOS
            </div>
            <h2 className="text-4xl font-bold text-[#0a1a2f] mb-4">Otimize Seu Tempo com Pacotes Completos</h2>
            <p className="text-xl text-stone-700">Programas estruturados para transformação duradoura</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {mediumTicket.map((service, index) => (
              <div
                key={index}
                className="bg-white p-8 rounded-3xl shadow-2xl border-4 border-blue-200 hover:border-blue-400 transition-all hover:shadow-3xl hover:-translate-y-2 relative overflow-hidden tilt-card"
                data-testid={`medium-ticket-card-${index}`}
              >
                {service.badge && (
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-1 rounded-full text-xs font-bold shadow-lg">
                    {service.badge}
                  </div>
                )}
                
                <div className="flex items-center gap-4 mb-6">
                  <div className={`bg-gradient-to-br ${service.color} text-white p-4 rounded-2xl shadow-lg`}>
                    <service.icon className="w-8 h-8" />
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-stone-900 mb-2">{service.title}</h3>
                {service.subtitle && (
                  <p className="text-blue-600 font-semibold mb-4">{service.subtitle}</p>
                )}
                
                <p className="text-stone-700 mb-6 text-lg">{service.description}</p>
                
                {service.modules ? (
                  <div className="mb-6">
                    <h4 className="font-bold text-stone-900 mb-3">8 Encontros:</h4>
                    <ul className="space-y-2">
                      {service.modules.slice(0, 4).map((module, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm text-stone-700">
                          <CheckCircle className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" />
                          <span>{module}</span>
                        </li>
                      ))}
                    </ul>
                    <p className="text-sm text-stone-600 mt-2 italic">+ 4 módulos adicionais</p>
                  </div>
                ) : (
                  <ul className="space-y-3 mb-6">
                    {service.benefits.map((benefit, i) => (
                      <li key={i} className="flex items-start gap-2 text-stone-700">
                        <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                )}

                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-6 rounded-2xl border-2 border-blue-300 mb-4">
                  <div className="text-center">
                    <p className="text-sm text-stone-600 mb-2">{service.priceLabel}</p>
                    <p className="text-4xl font-bold text-stone-900 mb-1">R$ {service.price}</p>
                    {service.installments && (
                      <p className="text-sm text-stone-600">ou {service.installments}</p>
                    )}
                  </div>
                </div>

                {service.bonus && (
                  <div className="bg-amber-50 p-4 rounded-xl border-2 border-amber-300 mb-4">
                    <p className="text-sm text-stone-800">
                      <span className="font-bold">🎁 BÔNUS:</span> {service.bonus}
                    </p>
                  </div>
                )}

                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(service.whatsappMsg)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white text-center py-4 rounded-xl font-bold hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl"
                  data-testid={`medium-ticket-cta-${index}`}
                >
                  Quero Este Programa
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HIGH TICKET Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#0a1a2f] to-[#0d2240]">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#c5a467] to-[#d4b574] text-[#0a1a2f] px-6 py-2 rounded-full font-bold mb-4 shadow-lg">
              <Award className="w-5 h-5" />
              INVESTIMENTO PREMIUM - HIGH TICKET
            </div>
            <h2 className="text-4xl font-bold text-white mb-4">Máxima Transformação Familiar</h2>
            <p className="text-xl text-stone-200">Para famílias que buscam resultados extraordinários</p>
          </div>
          
          {highTicket.map((service, index) => (
            <div
              key={index}
              className="bg-white p-12 rounded-3xl shadow-2xl border-4 border-gradient-to-r from-yellow-300 to-orange-300 relative overflow-hidden max-w-4xl mx-auto"
              data-testid="high-ticket-card"
            >
              <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-yellow-200 to-orange-200 rounded-full blur-3xl opacity-30"></div>
              
              {service.badge && (
                <div className="absolute top-6 right-6 bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-2 rounded-full text-sm font-bold shadow-lg">
                  {service.badge}
                </div>
              )}
              
              <div className="relative z-10">
                <div className="flex items-center gap-6 mb-8">
                  <div className={`bg-gradient-to-br ${service.color} text-white p-6 rounded-3xl shadow-2xl`}>
                    <service.icon className="w-12 h-12" />
                  </div>
                  <div>
                    <h3 className="text-4xl font-bold text-stone-900">{service.title}</h3>
                    <p className="text-orange-600 font-bold text-lg">{service.subtitle}</p>
                  </div>
                </div>
                
                <p className="text-xl text-stone-700 mb-4 font-medium">{service.description}</p>
                <p className="text-orange-600 mb-8 font-semibold text-lg italic">{service.highlight}</p>
                
                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div>
                    <h4 className="font-bold text-stone-900 mb-4 text-lg">Transformação Completa:</h4>
                    <ul className="space-y-3">
                      {service.benefits.slice(0, 3).map((benefit, i) => (
                        <li key={i} className="flex items-start gap-3 text-stone-700">
                          <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                          <span className="text-lg">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <h4 className="font-bold text-stone-900 mb-4 text-lg">Benefícios Extras:</h4>
                    <ul className="space-y-3">
                      {service.benefits.slice(3).map((benefit, i) => (
                        <li key={i} className="flex items-start gap-3 text-stone-700">
                          <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" />
                          <span className="text-lg">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-8 rounded-3xl border-4 border-orange-300 mb-6">
                  <div className="text-center">
                    <p className="text-lg text-stone-600 mb-3">{service.priceLabel}</p>
                    <p className="text-6xl font-bold text-stone-900 mb-3">R$ {service.price}</p>
                    <p className="text-lg text-stone-600">{service.installments}</p>
                  </div>
                </div>

                <div className="bg-gradient-to-r from-amber-100 to-orange-100 p-6 rounded-2xl border-2 border-orange-400 mb-6">
                  <p className="text-stone-800 text-lg">
                    <span className="font-bold text-xl">🎁 {service.bonus}</span>
                  </p>
                </div>

                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(service.whatsappMsg)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white text-center py-5 rounded-2xl font-bold text-xl hover:from-yellow-600 hover:via-orange-600 hover:to-red-600 transition-all shadow-2xl hover:shadow-3xl"
                  data-testid="high-ticket-cta"
                >
                  Quero a Transformação Completa
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-stone-900 mb-4">Depoimentos Reais</h2>
            <p className="text-xl text-stone-700">Veja o que dizem as famílias que já se transformaram</p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-amber-50 to-orange-50 p-6 rounded-2xl shadow-lg border-2 border-amber-200 hover:shadow-xl transition-all"
                data-testid={`testimonial-${index}`}
              >
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-yellow-500 text-yellow-500" />
                  ))}
                </div>
                <p className="text-stone-700 mb-4 italic leading-relaxed">"{testimonial.text}"</p>
                <div className="border-t border-amber-300 pt-4">
                  <p className="font-bold text-stone-900">{testimonial.author}</p>
                  <p className="text-sm text-stone-600">{testimonial.type}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="py-12 sm:py-16 md:py-20 px-4 bg-gradient-to-br from-stone-50 to-amber-50">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#0a1a2f] mb-16 text-center">Como Funciona</h2>
          <div className="grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="bg-gradient-to-br from-[#c5a467] to-[#d4b574] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white shadow-2xl">
                <span className="text-3xl font-bold text-[#0a1a2f]">1</span>
              </div>
              <h3 className="font-bold text-[#0a1a2f] mb-3 text-xl">Primeiro Contato</h3>
              <p className="text-stone-700 leading-relaxed">Entre em contato via WhatsApp e conte sobre suas necessidades. Respondo rapidamente!</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-[#c5a467] to-[#d4b574] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white shadow-2xl">
                <span className="text-3xl font-bold text-[#0a1a2f]">2</span>
              </div>
              <h3 className="font-bold text-[#0a1a2f] mb-3 text-xl">Escolha seu Caminho</h3>
              <p className="text-stone-700 leading-relaxed">Comece com Mentoria de Entrada ou vá direto para programas completos</p>
            </div>
            <div className="text-center">
              <div className="bg-gradient-to-br from-[#c5a467] to-[#d4b574] w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-white shadow-2xl">
                <span className="text-3xl font-bold text-[#0a1a2f]">3</span>
              </div>
              <h3 className="font-bold text-[#0a1a2f] mb-3 text-xl">Transformação</h3>
              <p className="text-stone-700 leading-relaxed">Receba estratégias práticas e veja sua família se transformar!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Localização */}
      <section className="py-12 sm:py-16 md:py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0a1a2f] mb-4">Localização</h2>
            <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-[#c5a467] to-[#d4b574] mx-auto rounded-full"></div>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-start">
            <div className="bg-gradient-to-br from-[#0a1a2f] to-[#0d2240] p-8 rounded-3xl shadow-2xl border-2 border-[#c5a467]">
              <h3 className="text-2xl font-bold text-[#c5a467] mb-6">Atendimento Presencial</h3>
              <div className="space-y-4 text-white">
                <div className="flex items-start gap-3">
                  <Home className="w-6 h-6 text-[#c5a467] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-[#c5a467] mb-1">Endereço:</p>
                    <p className="leading-relaxed">
                      Avenida Trindade, nº 254<br/>
                      Sala 301, 3º andar<br/>
                      Bethaville I<br/>
                      CEP: 06404-326<br/>
                      Carapicuíba - SP
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <Phone className="w-6 h-6 text-[#c5a467] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-[#c5a467] mb-1">Contato:</p>
                    <p>(11) 97396-4922</p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <Calendar className="w-6 h-6 text-[#c5a467] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold text-[#c5a467] mb-1">Salas Humanizadas:</p>
                    <p className="leading-relaxed">
                      Ambiente acolhedor e profissional<br/>
                      para seu conforto e privacidade
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-[#c5a467]/30">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Olá! Gostaria de agendar um atendimento presencial.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-[#c5a467] to-[#d4b574] text-[#0a1a2f] text-center py-3 rounded-xl font-bold hover:from-[#d4b574] hover:to-[#e3c481] transition-all shadow-lg"
                >
                  Agendar Atendimento
                </a>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-slate-50 to-blue-50 p-8 rounded-3xl shadow-xl border-2 border-[#c5a467]/30">
              <h3 className="text-2xl font-bold text-[#0a1a2f] mb-6">Atendimento Online</h3>
              <div className="space-y-4 text-stone-700">
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold mb-1">Videochamada Segura</p>
                    <p className="text-sm leading-relaxed">
                      Atendimento por plataforma profissional com total privacidade
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold mb-1">Flexibilidade de Horários</p>
                    <p className="text-sm leading-relaxed">
                      Atenda de qualquer lugar, no conforto da sua casa
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold mb-1">Mesma Qualidade</p>
                    <p className="text-sm leading-relaxed">
                      Atendimento profissional com a mesma excelência do presencial
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold mb-1">Atendimento em Todo Brasil</p>
                    <p className="text-sm leading-relaxed">
                      Não importa onde você esteja, posso te ajudar
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="mt-6 pt-6 border-t border-[#c5a467]/30">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent("Olá! Gostaria de agendar um atendimento online.")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white text-center py-3 rounded-xl font-bold hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg"
                >
                  Agendar Online
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-stone-900 mb-12 text-center">Perguntas Frequentes</h2>
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="border-2 border-stone-200 rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
                <button
                  onClick={() => setExpandedFaq(expandedFaq === index ? null : index)}
                  className="w-full p-6 text-left bg-gradient-to-r from-amber-50 to-orange-50 hover:from-amber-100 hover:to-orange-100 transition-all flex justify-between items-center"
                  data-testid={`faq-question-${index}`}
                >
                  <span className="font-bold text-stone-900 text-lg">{faq.question}</span>
                  <span className="text-3xl text-stone-800 font-bold">{expandedFaq === index ? '−' : '+'}</span>
                </button>
                {expandedFaq === index && (
                  <div className="p-6 bg-white">
                    <p className="text-stone-700 leading-relaxed text-lg">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-[#0a1a2f] via-[#0d2240] to-[#0a1a2f] text-white">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-5xl font-bold mb-6">Pronto para Se Reconhecer e Transformar Sua Família?</h2>
          <p className="text-2xl mb-12 opacity-90 leading-relaxed">
            Entre em contato agora e vamos juntos construir relações mais saudáveis, 
            comunicação eficaz e equilíbrio emocional duradouro
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <a
              href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-green-500 px-10 py-5 rounded-2xl font-bold text-xl hover:bg-green-600 transition-all shadow-2xl hover:shadow-3xl transform hover:-translate-y-1"
              data-testid="final-cta-whatsapp"
            >
              <Phone className="w-6 h-6" />
              WhatsApp: (11) 97396-4922
            </a>
            <a
              href="https://instagram.com/heroisdolar"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 bg-gradient-to-r from-purple-500 to-pink-500 px-10 py-5 rounded-2xl font-bold text-xl hover:from-purple-600 hover:to-pink-600 transition-all shadow-2xl hover:shadow-3xl transform hover:-translate-y-1"
              data-testid="final-cta-instagram"
            >
              <Instagram className="w-6 h-6" />
              @heroisdolar
            </a>
          </div>
          <p className="text-3xl font-bold mt-12 text-[#c5a467]">
            — Raphaela
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0a1a2f] text-white py-12 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <h3 className="font-bold text-xl mb-4 text-[#c5a467]">Raphaela Gonçalves</h3>
              <p className="text-sm opacity-75 leading-relaxed">
                Terapeuta e Mentora especializada em pais de adolescentes. 
                Transformando famílias através de comunicação eficaz e equilíbrio emocional.
              </p>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-4 text-[#c5a467]">Contato</h3>
              <p className="text-sm opacity-75 mb-2">📱 WhatsApp: (11) 97396-4922</p>
              <p className="text-sm opacity-75 mb-2">📧 E-mail: heroisdolar@outlook.com</p>
              <p className="text-sm opacity-75 mb-2">📍 Carapicuíba, São Paulo, BR</p>
              <p className="text-sm opacity-75 leading-relaxed">
                🏢 Avenida Trindade, nº 254, sala 301<br/>
                3º andar, Bethaville I<br/>
                CEP: 06404-326
              </p>
            </div>
            <div>
              <h3 className="font-bold text-xl mb-4 text-[#c5a467]">Redes Sociais</h3>
              <a
                href="https://instagram.com/heroisdolar"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm opacity-75 hover:opacity-100 transition-all flex items-center gap-2"
              >
                <Instagram className="w-5 h-5" />
                @heroisdolar
              </a>
            </div>
          </div>
          <div className="border-t border-[#c5a467]/20 pt-8 text-center">
            <p className="text-sm opacity-75">
              © 2024 Raphaela Gonçalves - Todos os direitos reservados
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}